import { Fetch } from '../shared/general';

//#region ======== ACTIONS ========
const actions = {
    //======== CLAIM MANAGEMENT ======
    branch_branch_create    : "branch_branch_create",
    branch_list_get         : "branch_list_get",
    branch_branch_update    : "branch_branch_update",
    branch_branch_remove    : "branch_branch_remove"
};
//#endregion


//#region ========== API FUNCTIONS ===========
export function branch_branch_create(data){
    return Fetch({ action: actions.branch_branch_create, data: data });
}

export function branch_list_get(data){
    return Fetch({ action: actions.branch_list_get, data: data });
}

export function branch_branch_update(data){
    return Fetch({ action: actions.branch_branch_update, data: data });
}

export function branch_branch_remove(data){
    return Fetch({ action: actions.branch_branch_remove, data: data });
}